<div class="omnisearch-container" fxLayout="row" fxLayoutAlign="start center">
  <form [formGroup]="searchForm" class="search-input" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="start center">
    <mat-icon *ngIf="loadingQuery$ | async as loadingQuery; else notLoading" class="search-input-icon spin">
      cached
    </mat-icon>
    <input #search formControlName="search" class="search-input-input"
      placeholder="Search across your organization's experts & projects..." (keydown.escape)="setFocus(false)"
      (click)="setFocus(true)" data-test-id="omnisearch-search-input">
    <mat-icon class="search-input-icon cancel" (click)="emptySearch()">
      close
    </mat-icon>
    <ng-template #notLoading>
      <mat-icon class="search-input-icon">search</mat-icon>
    </ng-template>
  </form>
</div>